import { render, staticRenderFns } from "./ResetNewPassword.vue?vue&type=template&id=2f918476&"
import script from "./ResetNewPassword.vue?vue&type=script&lang=js&"
export * from "./ResetNewPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports